export default __webpack_public_path__ + "793cfea1c08daa31d9fc3d91708e8a51.svg";